import { createSelector } from '@ngrx/store';
import { AppState } from '../states/app.state';
import { NavigationState } from '../states/navigation.state';

export const selectNavigation = (state: AppState) => state.navigation;

export const loadedRoutes = createSelector(
  selectNavigation,
  (state: NavigationState) => state.routes,
);

export const selectRoutes = createSelector(
  selectNavigation,
  (state: NavigationState) => state.routes,
);

export const selectEnabledRoutes = createSelector(
  selectNavigation,
  (state: NavigationState) => (state.routes || []).filter((r) => r.enabled !== false),
);

export const selectSelectedRoute = createSelector(
  selectNavigation,
  (state: NavigationState) => state.selectedRoute,
);
